/**
 * Homey Admin V2 API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ApplicationDto } from './application-dto';
import { UserSyncProcessingStateDto } from './user-sync-processing-state-dto';
import { HomeyStatus } from './homey-status';
import { HousingConnectProfileDto } from './housing-connect-profile-dto';
import { ConnectedAccountDto } from './connected-account-dto';
import { HouseholdIncomeDto } from './household-income-dto';
import { UserDtoNycProfile } from './user-dto-nyc-profile';
import { EmailDto } from './email-dto';
import { HomeyDomainEventAuditLogDto } from './homey-domain-event-audit-log-dto';
import { IgnoredReason } from './ignored-reason';
import { UserDtoSubscription } from './user-dto-subscription';


export interface ActiveUserDetailDto { 
    type: ActiveUserDetailDto.TypeEnum;
    id: string;
    anonymousId: string;
    status: HomeyStatus;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string;
    smsNotificationsEnabled: boolean;
    createdAt: string;
    lastSeen: string;
    source: string;
    birthDate?: string;
    trialing: boolean;
    rentalAssistance: boolean;
    subscription?: UserDtoSubscription;
    nycProfile?: UserDtoNycProfile;
    mails: Array<EmailDto>;
    /**
     * More emails exist than were returned -- the list is the newest page, not all of them.
     */
    mailsTruncated: boolean;
    householdSize?: number;
    /**
     * Undefined until the user has entered their household income.
     */
    householdIncome?: HouseholdIncomeDto;
    applications: Array<ApplicationDto>;
    domainEvents: Array<HomeyDomainEventAuditLogDto>;
    /**
     * More events exist than were returned -- the list is the newest page, not the whole history.
     */
    domainEventsTruncated: boolean;
    syncProcessingState?: UserSyncProcessingStateDto;
    ignore: boolean;
    ignoredReason: IgnoredReason;
    connectedAccounts: Array<ConnectedAccountDto>;
    housingConnectProfile?: HousingConnectProfileDto;
}
export namespace ActiveUserDetailDto {
    export const TypeEnum = {
        user: 'user'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


